import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

const BuyersContent = ({
  sidebarTitle,
  sidebarLinks = [],
  currentSlug,
  contentHeading,
  intro,
  sections = [],
  type = "buyers",
}) => {

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    }),
  };

  return (
    <>
      <section className="buyers-content-section container">

        {/* LEFT SIDEBAR */}

        <motion.div
          className="buyers-content-sidebar"
          initial={{
            opacity: 0,
            x: -40,
          }}
          whileInView={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
            amount: 0.2,
          }}
        >

          <motion.h3
            className="card-heading"
            initial={{
              opacity: 0,
              y: 20,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 0.7,
            }}
            viewport={{
              once: true,
            }}
          >
            {sidebarTitle}
          </motion.h3>

          <div className="buyers-sidebar-links">

            {sidebarLinks.map((item, index) => (

              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  x: -18,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                }}
           
                viewport={{
                  once: true,
                }}
              >

               <NavLink
  to={`/${type}/${item.slug}`}
  className={`buyers-sidebar-link ${
    currentSlug === item.slug
      ? "active-buyers-link"
      : ""
  }`}
>
  {item.title}
</NavLink>

              </motion.div>

            ))}

          </div>

        </motion.div>

        {/* RIGHT CONTENT */}

        <motion.div
          className="buyers-content-right"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.08,
          }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.12,
              },
            },
          }}
        >

          <motion.h3
            className="card-heading"
            variants={fadeUp}
          >
            {contentHeading}
          </motion.h3>

          <motion.p
            className="section-text buyers-intro"
            variants={fadeUp}
            custom={1}
          >
            {intro}
          </motion.p>

          {/* SECTIONS */}

          {sections.map((section, index) => (

            <motion.div
              className="buyers-step-block"
              key={index}
              custom={index}
              variants={fadeUp}
              whileHover={{
                y: -5,
              }}
              transition={{
                duration: 0.3,
              }}
            >

              {/* STEP / QUESTION HEADING */}

              <motion.h4
                className="buyers-step-heading"
                initial={{
                  opacity: 0,
                  y: 15,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.55,
                }}
                viewport={{
                  once: true,
                }}
              >

                {section.type === "faq"
                  ? `Q: ${section.heading}`
                  : section.number
                  ? `Step ${section.number}: ${section.heading}`
                  : section.heading}

              </motion.h4>

              {/* PARAGRAPHS */}

              {section.paragraphs &&
                section.paragraphs.map((para, i) => (

                  <motion.p
                    className="section-text buyers-step-para"
                    key={i}
                    initial={{
                      opacity: 0,
                      y: 18,
                    }}
                    whileInView={{
                      opacity: 1,
                      y: 0,
                    }}
                    transition={{
                      delay: i * 0.08,
                      duration: 0.5,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >
                    {para}
                  </motion.p>

                ))}

                  {section.advancedPointsSpecial &&
                section.advancedPointsSpecial.map((item, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">

                      <strong>
                        {item.title}
                      </strong>{" "}
                      {item.desc}

                    </li>

                  </motion.ul>

                ))}

              {/* SIMPLE POINTS */}

              {section.points &&
                section.points.map((point, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">
                      {point}
                    </li>

                  </motion.ul>

                ))}

                  {section.advancedPoints2 &&
                section.advancedPoints2.map((item, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">

                      <strong>
                        {item.title}
                      </strong>{" "}
                      {item.desc}

                    </li>

                  </motion.ul>

                ))}

                 {section.points2 &&
                section.points2.map((point, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">
                      {point}
                    </li>

                  </motion.ul>

                ))}

              {/* ADVANCED POINTS */}

              {section.advancedPoints &&
                section.advancedPoints.map((item, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">

                      <strong>
                        {item.title}
                      </strong>{" "}
                      {item.desc}

                    </li>

                  </motion.ul>

                ))}

               

 {section.advancedPoints3 &&
                section.advancedPoints3.map((item, i) => (

                  <motion.ul
                    className="buyers-points-list"
                    key={i}
                    initial={{
                      opacity: 0,
                      x: -15,
                    }}
                    whileInView={{
                      opacity: 1,
                      x: 0,
                    }}
                    transition={{
                      delay: i * 0.06,
                      duration: 0.45,
                    }}
                    viewport={{
                      once: true,
                    }}
                  >

                    <li className="section-text">

                      <strong>
                        {item.title}
                      </strong>{" "}
                      {item.desc}

                    </li>

                  </motion.ul>

                ))}



            </motion.div>

          ))}

        </motion.div>

      </section>
    </>
  );
};

export default BuyersContent;